"use client";
import { jsxs as r, jsx as i } from "react/jsx-runtime";
import _ from "clsx";
import { memo as l } from "react";
import { Box as n } from "../base/Base.js";
import '../../assets/GiftItem.css';const p = "_box_jy9px_1", d = "_free_jy9px_8", j = "__done_jy9px_11", v = "__active_jy9px_14", y = "_vip_jy9px_17", f = "_title_jy9px_26", N = "_text_jy9px_37", h = "_icon_jy9px_52", b = "_timer_jy9px_67", u = "_timer_icon_jy9px_80", t = {
  box: p,
  free: d,
  _done: j,
  _active: v,
  vip: y,
  title: f,
  text: N,
  icon: h,
  timer: b,
  timer_icon: u
}, g = l(
  ({ type: c = "free", title: a, icon: m, text: s, isActive: x, isDone: e, timer: o }) => /* @__PURE__ */ r(
    n,
    {
      gap: 4,
      center: !0,
      className: _(t.box, t[c], {
        [t._active]: x,
        [t._done]: e
      }),
      children: [
        o ? /* @__PURE__ */ r(n, { gap: 2, row: !0, align_center: !0, className: t.timer, children: [
          /* @__PURE__ */ i(
            "div",
            {
              className: _("material-icons", t.timer_icon),
              "data-icon": "timer"
            }
          ),
          o
        ] }) : /* @__PURE__ */ i(
          "div",
          {
            className: _(t.title, {
              [t._done]: e
            }),
            children: a
          }
        ),
        /* @__PURE__ */ i(
          "div",
          {
            className: _("material-icons", t.icon, t[c], {
              [t._done]: e
            }),
            "data-icon": e ? "check_circle" : m
          }
        ),
        /* @__PURE__ */ i(
          "div",
          {
            className: _(t.text, {
              [t._done]: e
            }),
            children: s
          }
        )
      ]
    }
  )
);
g.displayName = "GiftItem";
export {
  g as GiftItem
};
